import { render, staticRenderFns } from "./CardRegions.vue?vue&type=template&id=732cd700"
import script from "./CardRegions.vue?vue&type=script&lang=js"
export * from "./CardRegions.vue?vue&type=script&lang=js"
import style0 from "./CardRegions.vue?vue&type=style&index=0&id=732cd700&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports